import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';
import styled, { css } from 'styled-components';

export const Question = styled.div``;

export const Title = styled.div`
  white-space: break-spaces;

  ${applyStylesToMobileExperience(css`
    margin: 1rem 0;
  `)}
`;

export const Content = styled.div`
  max-width: 780px;
  display: block;
  margin: 0 auto;
`;

export const MeetMightyProTextBlock = styled.div`
  display: grid;
  row-gap: 1.5rem;
  max-width: 900px;
  margin: 0 auto;
`;

export const MeetMightyProCTAWrapper = styled.div`
  display: flex;
  justify-content: center;

  ${applyStylesToMobileExperience(css`
    margin-top: 2rem;
  `)}
`;
